import React, { useEffect } from "react";
import Menu from "./menu";
import "../../assets/styles/styles.scss";
import SubMenu from "./menu/sub-menu";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { URL } from "../../routers/constants";
import { regexUrlMatch } from "../../services/helpers/Helper";
import { fetchCurentPage, fetchPages } from "../../store/action/pageAction";

const Main = (props) => {
   const { children, subMenus, hideMenu, fetchCurentPage, fetchPages } = props;
   const location = useLocation();
   const navigate = useNavigate();

   const showOrHideMenuWhenScreenInbox = () => {
      return !(hideMenu && regexUrlMatch([URL.INBOX], location.pathname));
   }

   useEffect(() => {
      fetchPages(navigate);
      fetchCurentPage();

   }, []);

   return (
      <React.Fragment>
         <div id="react-app">
            <div className="root-app">
               <div className="container-fluid">
                  <div className="row">
                     <div className="col-sm-12 p-none new-UI">
                        <div className="wrap-notification-container">
                           <div className="notification-container notification-container-empty">
                              <span></span>
                           </div>
                        </div>
                        <div>
                           <div id="bot-container" className="col-sm-12 p-none">
                              {showOrHideMenuWhenScreenInbox() &&
                                 <div className={`app-messaging-first--section-menu ${subMenus.menus && subMenus.menus.length > 0 && "app-messaging-first--section-menu--has-child"} `}>
                                    <div className="app-messaging-first--section-menu--container">
                                       <Link to={URL.HOME}>
                                          <div className="app-messaging-first--logo">
                                             <a >
                                                <img src={"https://app.viettelmedia.vn/favicon.png"} />
                                             </a>
                                          </div>
                                       </Link>
                                       <Menu />
                                    </div>
                                    <SubMenu />
                                 </div>
                              }
                              {children}
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </React.Fragment>
   )
}

const mapStateToProps = (state) => {
   const { subMenus, generalSettings } = state;
   return {
      subMenus,
      hideMenu: generalSettings.hideMenu
   };
};

export default connect(mapStateToProps, {
   fetchPages,
   fetchCurentPage
})(Main);
